
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9Dgyh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7272c3dfe0a49c7c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $7272c3dfe0a49c7c$export$2e2bcd8739ae039 = {
    'fabric.editor.headingLink.ascSortingLabel': "\u6607\u9806",
    'fabric.editor.headingLink.copied': "\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F",
    'fabric.editor.headingLink.copyAnchorLink': "\u898B\u51FA\u3057\u3078\u306E\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.editor.headingLink.copyAriaLabel': "\u30B3\u30D4\u30FC",
    'fabric.editor.headingLink.descSortingLabel': "\u964D\u9806",
    'fabric.editor.headingLink.failedToCopy': "\u30B3\u30D4\u30FC\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
    'fabric.editor.headingLink.noneSortingLabel': "\u306A\u3057",
    'fabric.editor.inlineComment.marker.end': "\u30A4\u30F3\u30E9\u30A4\u30F3 \u30B3\u30E1\u30F3\u30C8\u7D42\u4E86",
    'fabric.editor.inlineComment.marker.start': "\u30A4\u30F3\u30E9\u30A4\u30F3 \u30B3\u30E1\u30F3\u30C8\u958B\u59CB"
};

});


//# sourceMappingURL=ja.f4317409.js.map
